/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionsnoplaces2Inputs */

const en_actionsnoplaces2 = /** @type {(inputs: Actionsnoplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a place first. An action always belongs to a place.`)
};

const de_actionsnoplaces2 = /** @type {(inputs: Actionsnoplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg zuerst einen Ort an. Eine Aktion gehört immer zu einem Ort.`)
};

/**
* | output |
* | --- |
* | "Create a place first. An action always belongs to a place." |
*
* @param {Actionsnoplaces2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionsnoplaces2 = /** @type {((inputs?: Actionsnoplaces2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionsnoplaces2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionsnoplaces2(inputs)
	return de_actionsnoplaces2(inputs)
});
export { actionsnoplaces2 as "actionsNoPlaces" }